import { apiClient } from "../../../api/client";
import * as ActionType from "./promoCode.type";
import { setToast } from "../../../util/toast";

export const getPromoCode = () => async (dispatch) => {
  const res = await apiClient.get("promoCode/getPromoCode");
  if (res.ok) {
    dispatch({ type: ActionType.GET_PROMOCODE, payload: res.data?.promoCodes });
  } else {
    console.log(res.message);
  }
};

export const createPromoCode = (data) => async (dispatch) => {
  const res = await apiClient.post("promoCode/createPromoCode", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_PROMOCODE, payload: res.data?.promoCode });
    setToast("success", "Promo code created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updatePromoCode = (data) => async (dispatch) => {
  const res = await apiClient.patch("promoCode/updatePromoCode", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_PROMOCODE, payload: res.data?.promoCode });
    setToast("success", "Promo code updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deletePromoCode = (id) => async (dispatch) => {
  const res = await apiClient.delete(`promoCode/deletePromoCode?promoCodeId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_PROMOCODE, payload: id });
    setToast("success", "Promo code deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
